import * as React from 'react';
import SignIn from '../Components/SignIn.tsx';
import SignUp from '../Components/SignUp.tsx';
import LandingPage from '../Components/LandingPage.tsx'; // Import the LandingPage component

interface AuthPageProps {
    onSignInSuccess: () => void;
}

export default function Authpage({ onSignInSuccess }: AuthPageProps) {
    const [currentPage, setCurrentPage] = React.useState<'landing' | 'signin' | 'signup'>('landing');

    const switchToSignUp = () => setCurrentPage('signup');
    const switchToSignIn = () => setCurrentPage('signin');

    return (
        <>
            {currentPage === 'landing' && <LandingPage onGetStarted={switchToSignIn} />}
            {currentPage === 'signin' && <SignIn switchToSignUp={switchToSignUp} onSignInSuccess={onSignInSuccess} />}
            {currentPage === 'signup' && <SignUp switchToSignIn={switchToSignIn} />}
        </>
    );
}
